<script setup lang="ts">
import {ArrowLeft, ArrowRight, Building2, BriefcaseBusiness, HardHat, UsersRound} from 'lucide-vue-next';
import {RouterLink} from 'vue-router';
import {useLanguage} from '../composables/useLanguage';

const {isArabic} = useLanguage();

const stats = [
  {value: '+250', ar: 'مشروع منفذ', en: 'Completed projects', icon: Building2},
  {value: '+18', ar: 'عاماً من الخبرة', en: 'Years of experience', icon: BriefcaseBusiness},
  {value: '+900', ar: 'عميل وشريك نجاح', en: 'Clients and partners', icon: UsersRound},
  {value: '5', ar: 'مدن ومناطق تغطية', en: 'Covered regions', icon: HardHat},
];
</script>

<template>
  <section id="home" class="hero">
    <div class="hero__overlay"></div>
    <div class="container hero__content">
      <div class="hero__copy reveal">
        <span class="hero__kicker">{{ isArabic ? 'مقاولات عامة • بنية تحتية • استثمار عقاري' : 'Contracting • Infrastructure • Real Estate' }}</span>
        <h1>
          {{ isArabic ? 'شركة القَصواء الكبرى' : 'ALQASWA ALKOBRA' }}
          <span>{{ isArabic ? 'للمقاولات العامة والاستثمار العقاري' : 'General Contracting & Real Estate Investment' }}</span>
        </h1>
        <p>{{ isArabic ? 'نبني مشاريع بثقة، ونطور استثمارات عقارية بمعايير احترافية في جميع أنحاء ليبيا.' : 'We build with confidence and develop real estate investments to professional standards across Libya.' }}</p>
        <div class="hero__actions">
          <RouterLink to="/contact" class="button button--primary">
            {{ isArabic ? 'تواصل معنا' : 'Contact us' }}
            <ArrowLeft v-if="isArabic" :size="18" />
            <ArrowRight v-else :size="18" />
          </RouterLink>
          <RouterLink to="/vision" class="button button--ghost">{{ isArabic ? 'استكشف رؤيتنا' : 'Explore our vision' }}</RouterLink>
        </div>
      </div>
    </div>
    <div class="container hero__stats">
      <article v-for="stat in stats" :key="stat.value" class="stat-card">
        <component :is="stat.icon" :size="28" />
        <div><strong>{{ stat.value }}</strong><span>{{ isArabic ? stat.ar : stat.en }}</span></div>
      </article>
    </div>
  </section>
</template>
